export enum HeaderType {
  WithMobileHeader = 'withMobileHeader',
}
